
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Blogcss from '../assets/css/Blog.css';
import blog from '../assets/images/blog.jpg';

function Blog() {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(false);

    const BASE_URL = process.env.REACT_APP_HOST_API_URL;

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            setLoading(true);
            const response = await fetch(
                `${process.env.REACT_APP_HOST_API_URL}/api/blogs/`
            );
            const data = await response.json();
            setBlogs(data.data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="blog-root">

            {/* HERO — unchanged */}
            <div
                className="base blog-base"
                style={{ backgroundImage: `url(${blog})` }}
            >
                <div className="child-block blog-child">
                    <Navbar />
                    <div className="blog-hero-text">
                        <h1>UniversalHRA Blogs</h1>
                        <h5>Latest HR, Payroll, Tax & Compliance Updates</h5>
                    </div>
                </div>
            </div>

            {/* BLOG CONTENT */}
            <div className="blog-container">

                {loading ? (
                    <div className="loading">Loading Blogs...</div>
                ) : (
                    <div className="blog-list">
                        {blogs.map((blog) => {
                            const image = blog.thumbnail
                                ? `${BASE_URL}${blog.thumbnail}`
                                : null;

                            return (
                                <Link
                                    key={blog.id}
                                    to={`/blog/${blog.slug}`}
                                    className="blog-card"
                                >
                                    {/* Always render image slot for consistent layout */}
                                    {image ? (
                                        <div className="blog-image">
                                            <img src={image} alt={blog.title} />
                                        </div>
                                    ) : (
                                        <div className="blog-image-placeholder">
                                            📰
                                        </div>
                                    )}

                                    <div className="blog-content">
                                        <p className="date">
                                            {new Date(blog.created_at).toDateString()}
                                        </p>
                                        <h2 className="title">{blog.title}</h2>
                                        <p className="desc">{blog.short_description}</p>
                                        <span className="read-more">Read more →</span>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                )}

            </div>

            <Footer />
        </div>
    );
}

export default Blog;